module.exports = {"370871001":"洸河街道","370871002":"柳行街道","370871003":"接庄街道","370871004":"王因街道","370871005":"黄屯街道","370871400":"济东物业服务中心"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370871.json
// module id = 1434
// module chunks = 0